export default __webpack_public_path__ + "static/media/ilus-badge-expert.6788ad6f.svg";